<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="textn"> </p>
<p class="textn"> </p>
<p class="textn">Mom in a restaurant is like a single guy at a party.
Her eyes are always busy.</p>
<p class="textn">Who’s here?</p>
<p class="textn">Who might need me?</p>
<p class="textn">Who has a spot she can’t get out?</p>
<p class="textn">Who needs a dab more mashed potatoes?</p>
<p class="textn">Who has a loose shoelace?</p>
<p class="textn">Who can’t read the menu?</p>
<p class="textn">Who needs a button fixed?</p>
<p class="textn">Who needs a tissue?</p>
<p class="textn">Who needs a shoulder?</p>
<p class="textn">Who needs help with the door?</p>
<p class="textn">Who needs directions to the rest room?</p>
<p class="textn">Who needs a compliment?</p>
<p class="textn">Who needs his faith restored?</p>
<p class="textn">Who needs a friend?</p>
<p class="textn">Who needs a husband or a wife?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mom007.vue?52027709